import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCashRegister, faLock, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useCaja } from './CajaContext';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moneda, { formatearMoneda, parsearMoneda } from '../moneda';
import baseURL from '../url';
import storage from '../storage';
import { ruta } from '../paths';

export default function AbrirCajaModal() {
    const { abrirCaja } = useCaja();
    const [monto, setMonto] = useState('');
    const [enviando, setEnviando] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleAbrir = async (e) => {
        e.preventDefault();
        setErrorMsg('');
        const montoLimpio = parsearMoneda(monto);
        if (montoLimpio === '' || isNaN(montoLimpio)) {
            toast.error('Ingresá el monto inicial');
            return;
        }
        setEnviando(true);
        try {
            const res = await abrirCaja(montoLimpio);
            setEnviando(false);
            if (res?.error) {
                setErrorMsg(res.error);
                toast.error(res.error);
            } else if (res?.idCaja) {
                toast.success('Caja abierta');
            } else {
                setErrorMsg('Respuesta inesperada del servidor');
                console.error('Respuesta cajaPost:', res);
            }
        } catch (err) {
            setEnviando(false);
            setErrorMsg('Error de conexión: ' + err.message);
            console.error(err);
        }
    };

    const handleLogout = async () => {
        try {
            await fetch(`${baseURL}/logout.php`, { method: 'GET' });
        } catch (err) {
            // ignoramos errores de red, igual cerramos sesion local
        }
        storage.removeItem('adminUser');
        window.location.href = ruta('/');
    };

    return (
        <div style={{
            position: 'fixed', inset: 0,
            background: 'rgba(15, 20, 35, 0.95)',
            zIndex: 99998,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '20px',
        }}>
            <ToastContainer />
            <div style={{
                background: '#fff', borderRadius: '14px',
                padding: '32px 28px', maxWidth: '440px', width: '100%',
                textAlign: 'center',
                boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
            }}>
                <div style={{
                    width: '72px', height: '72px', borderRadius: '50%',
                    background: '#e7f7ee', margin: '0 auto 16px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    <FontAwesomeIcon icon={faCashRegister} style={{ fontSize: '32px', color: '#28a745' }} />
                </div>
                <h2 style={{ margin: '0 0 8px', fontSize: '22px', color: '#212529' }}>Abrir caja del día</h2>
                <p style={{ color: '#6c757d', fontSize: '14px', margin: '0 0 20px' }}>
                    <FontAwesomeIcon icon={faLock} /> No podés tomar pedidos hasta abrir la caja
                </p>

                <form onSubmit={handleAbrir}>
                    <label style={{ display: 'block', textAlign: 'left', fontSize: '13px', fontWeight: 600, color: '#495057', marginBottom: '6px' }}>
                        Monto inicial en efectivo ({moneda})
                    </label>
                    <input
                        type='text'
                        inputMode='numeric'
                        value={monto}
                        onChange={(e) => setMonto(formatearMoneda(e.target.value))}
                        placeholder='0'
                        autoFocus
                        style={{
                            width: '100%', padding: '12px 14px', fontSize: '18px',
                            border: '2px solid #e9ecef', borderRadius: '8px',
                            outline: 'none', textAlign: 'center',
                            boxSizing: 'border-box', marginBottom: '12px',
                        }}
                    />

                    {errorMsg && (
                        <div style={{
                            background: '#fde8e9', border: '1px solid #dc3545',
                            color: '#721c24', padding: '10px 12px',
                            borderRadius: '8px', fontSize: '13px',
                            marginBottom: '12px', textAlign: 'left',
                        }}>
                            ❌ {errorMsg}
                        </div>
                    )}

                    <button
                        type='submit'
                        disabled={enviando}
                        style={{
                            width: '100%', padding: '14px',
                            background: enviando ? '#6c757d' : '#28a745',
                            color: '#fff', border: 'none', borderRadius: '8px',
                            fontSize: '16px', fontWeight: 700,
                            cursor: enviando ? 'wait' : 'pointer',
                        }}
                    >
                        {enviando ? 'Abriendo...' : 'Abrir caja'}
                    </button>
                </form>

                <div style={{ marginTop: '18px', paddingTop: '16px', borderTop: '1px solid #e9ecef' }}>
                    <button
                        type='button'
                        onClick={handleLogout}
                        style={{
                            width: '100%', padding: '10px',
                            background: 'transparent',
                            color: '#dc3545',
                            border: '1.5px solid #dc3545',
                            borderRadius: '8px',
                            fontSize: '13px', fontWeight: 600,
                            cursor: 'pointer',
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                        }}
                    >
                        <FontAwesomeIcon icon={faSignOutAlt} /> Cerrar sesión
                    </button>
                </div>
            </div>
        </div>
    );
}
